namespace('compass.group');
compass.require('compass.hotel.EditReservationDatesWidget');
compass.require('compass.group.RoomManageWidget');

compass.group.RoomTypeArriveDepartWidget = compass.defineWidget(function RoomTypeArriveDepartWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;
	var _editReservationDatesWidget;

	var _roomTypesWidget;
	var _reservationDatesContainer;
	var _roomTypesContainer;

	var selectedRoomId;
	var selectedRoomType;
	var selectedUnassignedRoom;
	var currentRoomTypeDatesEditable = true;

	var _roomTypesData;
	var _requestedRooms = _settings.requestedRooms;
	var _checkInDate  = _settings.selectedArrive || null;
	var _checkOutDate = _settings.selectedDepart || null;
	var _roomSelect; /*date range dropdown*/

	var fullDateFormat = compass.util.dateFormatter('ddd, mmm d, yyyy');

	if(_settings.translate) {
		/*translate data from the new structure to the old*/
		_roomTypesData = _.map(_settings.roomTypes, function(roomType) {
			roomType.avgNightlyRate = roomType.avgRate,
			roomType.name = roomType.roomTypeBase.name;
			roomType.occupants = roomType.roomTypeBase.occupancy;
			roomType.minNights = roomType.roomTypeBase.minimum_nights;
			roomType.blockedRoomId = roomType.blocked_room_id;

			var translateNights = _.map(roomType.nights,function(night){
				night.availInfo = night.availBase.availInfo;
				night.restrictions = night.availBase.dateRestrictionBase;
				night.date = night.nightBase.night;
				night.roomPrice = night.availBase.roomPrice;
				night.inclusiveRoomPrice = (night.availBase.inclusiveRoomPrice || night.availBase.roomPrice);
				return night;
			});
			roomType.nights = translateNights;

			return roomType;
		});
	} else {
		_roomTypesData = _settings.roomTypes;
	}

	me.updateRoomType = function(roomTypes) {
		var currentRoomType = parseInt(me.find('.roomTypes option:selected').val());
		_settings.roomTypes = roomTypes;
		currentRoomType = _.find(_settings.roomTypes, function(roomType) {
			return roomType.roomTypeBase.room_id === currentRoomType;
		});
	};

	var _drawReservationDatesWidget = function(roomType, selectedAvailabilityInfoBasedOnCheckin) {
		var curArriveDate = _checkInDate || null;
		var curDepartDate = _checkOutDate || null;
		var nightsBasedOnCheckin = selectedAvailabilityInfoBasedOnCheckin ? selectedAvailabilityInfoBasedOnCheckin.nights : [];

		_reservationDatesContainer.empty();
		_editReservationDatesWidget = new compass.hotel.EditReservationDatesWidget(_reservationDatesContainer, {
			nights : roomType.nights,
			currentCheckInDate : curArriveDate,
			currentCheckOutDate : curDepartDate,
			unassignedRoomsInfo : _settings.unassignedRoomsInfo,
			nightsBasedOnCheckin : nightsBasedOnCheckin,
			minimumNights : roomType.minNights,
			translate: _settings.translate,
			onChange: _settings.onChange,
			preHandleClick: ( _settings.processClickOnRoomTypes === false ? function(){return false;} : function(){return true;}) ,
			selectOptionText: _settings.selectOptionText,
		});

		// these editReservationDatesWidget methods need to be exposed so editReservationWidget can use them
		me.datesValidationMessage = _editReservationDatesWidget.validationMessage;
		me.datesGrabValues = _editReservationDatesWidget.grabValues;
	};

	var _drawUneditableDates = function() {
		_reservationDatesContainer.empty().addClass('uneditable').append(
			d.fieldLabelPair({className: 'uneditableArrive', label: _settings.labels.arrive },
				d.div(fullDateFormat(compass.util.parse.ISODateParser(_checkInDate)))
			),
			d.fieldLabelPair({className: 'uneditableDepart', label: _settings.labels.depart},
				d.div(fullDateFormat(compass.util.parse.ISODateParser(_checkOutDate)))
			)
		);
	};

	var _drawUneditableRoomTypes = function() {
		_roomTypesContainer.addClass('uneditable');
		_roomTypesContainer.append(
			d.fieldLabelPair({className: 'uneditableRoomType', label: _settings.labels.roomType}, d.div(selectedRoomType.name))
		);
	};

	var _drawDateSelect = function(unassignedRooms, currentBlockRoomId) {
		var curArriveDate = _checkInDate || null;
		var curDepartDate = _checkOutDate || null;
		var singleOption = unassignedRooms.length <= 1;
		
		var _drawArriveAndDepartDates = function(unassignedRoom) {
			return d.div({className: 'dates'},
				d.div({className: 'arrive'}, fullDateFormat(compass.util.parse.ISODateParser(unassignedRoom.arrive))),
				d.div({className: 'depart'}, fullDateFormat(compass.util.parse.ISODateParser(unassignedRoom.depart)))
			); 
		};
		
		// filter out only the selected roomtype's stay dates ranges
		var filteredUnassignedRooms = _.filter(unassignedRooms, function(unassignedRoom) {
			return unassignedRoom.blocked_room_id === currentBlockRoomId; 
		});

		_roomSelect = d.dataSelect({
			data : filteredUnassignedRooms,
			className : 'roomSelect',
			classMapper :	function() {},
			labelMapper : _drawArriveAndDepartDates,
			choiceMapper : _drawArriveAndDepartDates,
			initialSelection : 0,
			change: function(unassignedRoom) {
				me.find('.dataSelect.roomSelect').removeClass('invalid');
				_settings.onChange();
				selectedUnassignedRoom = unassignedRoom;
				_checkInDate = selectedUnassignedRoom.arrive;
				_checkOutDate = selectedUnassignedRoom.depart;
			},
			defaultBlank: singleOption ? false : true
		});

		if(singleOption) {
			selectedUnassignedRoom = unassignedRooms[0];
			_checkInDate = unassignedRooms[0].arrive;
			_checkOutDate = unassignedRooms[0].depart;
		} else {
			_roomSelect.find('.dataSelectInputLabel').append(_settings.labels.roomSelectDefault);
		}
		_reservationDatesContainer.empty();
		_reservationDatesContainer.append(d.fieldLabelPair({className: 'roomSelectContainer', label: _settings.labels.roomSelect}, _roomSelect));
	};

	me.validateDates = function(){
		/*validate dates if they are separated into arrive and depart dropdowns*/
		var datesGood = true;
		/*if we have one date range dropdown, validate it, otherwise, validate arrive/depart dropdowns */
		
		if(_roomSelect !== undefined){
			if(!selectedUnassignedRoom){
				d.errorBubble({
					elem : _roomSelect,
					errorMessage : 'A stay range is required'
				});
				datesGood = false;
			}
		}
		else if(_editReservationDatesWidget){
			datesGood = _editReservationDatesWidget.validateDates();
		}
		return datesGood;
	};

	me.grabValues = function() {
		var arrive;
		var depart;
		var blocked_room_id;
		if(currentRoomTypeDatesEditable) {
			arrive = _editReservationDatesWidget.getArriveDepart().arrive;
			depart = _editReservationDatesWidget.getArriveDepart().depart;
			blocked_room_id = _roomTypesWidget.grabValues().blocked_room_id;
		} else {
			arrive = _checkInDate;
			depart = _checkOutDate;
			blocked_room_id = selectedRoomType.blocked_room_id;
		}
		return {
			blocked_room_id: blocked_room_id,
			arrive : arrive,
			depart : depart
		};
	};

	var sortRoomTypes = function() {
		var newCheckInDate, newCheckOutDate;
		if(currentRoomTypeDatesEditable) {
			var dates = _editReservationDatesWidget.grabValues();
			newCheckInDate = dates.nights.length ? _.first(dates.nights).nightDate : null;
			newCheckOutDate = dates.nights.length ? _.last(dates.nights).nightDate : null;
		} else {
			newCheckInDate = selectedUnassignedRoom ? selectedUnassignedRoom.arrive : null;
			newCheckOutDate = selectedUnassignedRoom ? selectedUnassignedRoom.depart : null;
		}

		/*loop through the nights and make sure that the nights that they already have booked are marked as available */
		var nightsForRoomType = selectedRoomType.nights;
		var currentNights = _.filter(nightsForRoomType, function(n) {
			var thedate = n.date || n.nightBase.night;
			return n.date >= _checkInDate && n.date < _checkOutDate;
		});
		_.each(currentNights, function(n) {
			n.availInfo = 'AVAIL';
		});

		if(_checkInDate !== newCheckInDate || _checkOutDate !== newCheckOutDate) {
			_checkInDate = newCheckInDate;
			_checkOutDate = newCheckOutDate;
			if (!_settings.onlyStayRanges) {
				setupRoomTypes(_settings.roomTypes, _checkInDate, _checkOutDate, _requestedRooms);
			}
			me.find('.RoomTypesWidget .dataSelect').trigger('rebuildContent', { choices: _settings.roomTypes });
		}
	
		// this gets passed to preHandleClick on the dataselect. unless === false it will continuing process so being undefined was the same as true.
		return true;
	};

	var roomTypesRateMapper = function(rt) {
	    var _local_checkInDate = _checkInDate || _settings.meetingInfo.peakNight;
	    var _local_checkOutDate = _checkOutDate || _settings.meetingInfo.DayAfterPeakNight;
	    
	    var selectedDates = _.filter(rt.nights, function(night) {
	    	return (_local_checkInDate <= night.date && night.date < _local_checkOutDate);
	    });
	    var rates = _.map(selectedDates, function(night) { return (night.inclusiveRoomPrice || night.roomPrice); });
		if ( rates.length ===  0 ){ 
			return rt.avgRate;
		}
	    return _.reduce(rates, function(totalRate, rate) { return totalRate + rate; }, 0) / rates.length;
	};

	var roomTypesAvailabilityMapper = function(rt) {
		var selectedDates = _.filter(rt.nights, function(night) {
			return (_checkInDate <= night.date && night.date < _checkOutDate);
		});
		return _.min(_.map(selectedDates, function(night) { return night.availCount; }));
	};

	var setupRoomTypes = function(roomTypes, checkInDate, checkOutDate, requestedRooms) {
		// Sort room types
		_.each(roomTypes, function(rt) {
			rt.currAvail = _.foldl(rt.nights, function(m, n) { return m + Number(n.availCount); }, 0);

			var requestedDates = _.filter(rt.nights, function(rn) {
				return (checkInDate <= rn.date && rn.date < checkOutDate);
			});
			// first, make sure that the number of nights requested meets the minium night stay requirement
			// if so, mark the room type as unavailable
			if(requestedDates.length < rt.minNights){
				rt.requestedDatesAvail = false;
			}
			else{
				// the minimum night requirement was met
				// check to make sure every night in the date range is available  and if so change the availability of this room type as true
				rt.requestedDatesAvail = _.every(requestedDates, function(rn) {
					return (rn.availInfo === 'AVAIL');
				});
			}
			
			// flag the room type as limited availability if across the date range we can't fully satisfy the requested number of rooms
			rt.limitedAvail = roomTypesAvailabilityMapper(rt) <= _requestedRooms;		
		});

		roomTypes = _(roomTypes).chain()
			.sortBy(function(rtype){return rtype.name;})
			.sortBy(function(rtype){return rtype.occupants;})
			.sortBy(function(rtype){return _settings.showPrice ? Number(roomTypesRateMapper(rtype)) : 1;})
			.sortBy(function(rtype){return (rtype.requestedDatesAvail && !rtype.limitedAvail) ? 0 : 1;}) /* if dates are avail and not limited avail then 0 which will put them first above 1.*/
			.value();
	};

	me.render = function(widgetElem) {
		var selectedBlocked_room_id = _settings.selectedBlocked_room_id || _settings.mostCommonBlocked_room_id;
		selectedRoomType = _.find(_roomTypesData, function(roomType) {
			var blocked_room_id_local = roomType.blocked_room_id || roomType.blockedRoomId;
			return blocked_room_id_local === selectedBlocked_room_id;
		});

		var selectedAvailabilityInfoBasedOnCheckin = _.find(_settings.availabilityInfoBasedOnCheckin, function(roomType) {
			var blocked_room_id_local = roomType.blocked_room_id || roomType.blockedRoomId;
			return blocked_room_id_local === selectedBlocked_room_id;
		});

		if(_settings.onlyStayRanges === true || !selectedRoomType.canEditRoomType) {
			currentRoomTypeDatesEditable = false;
		}

		_roomTypesContainer = d.div({className: 'roomTypesContainer'});
		_reservationDatesContainer = d.div({className: 'reservationDatesContainer'});

		widgetElem.append(
			_roomTypesContainer,
			_reservationDatesContainer
		);

		setupRoomTypes(_settings.roomTypes, _checkInDate, _checkOutDate, _requestedRooms);
		if(_settings.editable || !_settings.selectedRoomType) {
			var roomTypesEditable = true;
			// this handles when we are typically editing an existing reservaiton, and the room type can't be changed.
			// room type is not editable ( generally permissioned ) and a room type has been selected meaning it is an assigned room
			if ( !selectedRoomType.canEditRoomType && _settings.selectedRoomType ) roomTypesEditable = false;
			if(!roomTypesEditable) {
				_drawUneditableRoomTypes();
			} else {
				_roomTypesWidget = new compass.hotel.RoomTypesWidget(_roomTypesContainer, {
					meetingInfo : _settings.meetingInfo,
					roomTypes : _roomTypesData,
					initialSelection: selectedBlocked_room_id,
					preHandleClick: ( _settings.processClickOnRoomTypes === false ? function(){return false;} : sortRoomTypes ) ,
					classMapper: function() {},
					rateMapper: roomTypesRateMapper,
					availabilityMapper: roomTypesAvailabilityMapper,
					onChange: _settings.onChange,
					showPrice: _settings.showPrice,
					showAvail: false
				});
				me.roomTypeGrabValues = _roomTypesWidget.grabValues;

				_roomTypesWidget.bind('RoomTypesWidget.roomTypeChanged', function(e, blockedRoomId) {
					selectedRoomType = _.find(_roomTypesData, function(roomType) {
						return (roomType.blocked_room_id || roomType.blockedRoomId) === blockedRoomId;
					});

					var isUnassigned = !_settings.selectedRoomType;
					me.trigger("RoomTypeArriveDepartWidget.roomTypeChanged", isUnassigned);

					if(_settings.onlyStayRanges === true || !selectedRoomType.canEditRoomType) {
						currentRoomTypeDatesEditable = false;
						_drawDateSelect(_settings.unassignedRoomsInfo, blockedRoomId);
					} else {
						/*we're working with the editReservationWidget as opposed to a dateSelect*/
						currentRoomTypeDatesEditable = true;
						/*we only remove and redraw the dates via the editReservationDates widget if dates for the PREVIOUSLY chosen room type were uneditable */
						_drawReservationDatesWidget(selectedRoomType, selectedAvailabilityInfoBasedOnCheckin);
						_editReservationDatesWidget.validateDates();
					}
				});
			}
			
			if(currentRoomTypeDatesEditable) {
				_drawReservationDatesWidget(selectedRoomType, selectedAvailabilityInfoBasedOnCheckin);
			} else if(_checkInDate && _checkOutDate && currentRoomTypeDatesEditable ) {
				_drawUneditableDates();
			} else {
				_drawDateSelect(_settings.unassignedRoomsInfo, _settings.mostCommonBlocked_room_id);
			}

			me.bind("EditReservationDatesWidget.datesChange", function(event, eventData) {
				if(_settings.selectedRoomType) {
					var gaEvent = "RoomTypeArriveDepartWidget.assignedDateChange";
				} else {
					var gaEvent = "RoomTypeArriveDepartWidget.unassignedDateChange";
				}
				me.trigger(gaEvent, eventData);
			});

			// when drawing uneditable unassigned roomType and arrive/depart
			if(!_settings.editable && !_settings.selectedRoomType) {
				widgetElem.find('.dataSelect').trigger('disable');
			}
		} else {
			_drawUneditableRoomTypes();
			_drawUneditableDates();
		}
	};
}, {
	WUID: 'DEFAULT',
	widgetName: 'RoomTypeArriveDepartWidget',
	meetingInfo: {},
	editable: true,
	onlyStayRanges: false,
	roomTypes: [],
	availabilityInfoBasedOnCheckin : [],/* room types that whose availability information doesn't get changed when the initial check in dropdown gets clicked (this availability is used after a checkin date is selected)*/
	nights: [],
	selectedBlocked_room_id: '',
	mostCommonBlocked_room_id: '',
	selectedArrive: '',
	selectedDepart: '',
	unassignedRoomsInfo : [],
	onChange: function() {},
	requestedRooms: 1,
	translate: false,
	showPrice : true,
	processClickOnRoomTypes : true,
	// this is so the widget knows if the roomType actually belongs to the user or if it's just a default selection
	selectedRoomType : true,
	labels: {
		arrive: 'Check-In',
		depart: 'Check-Out',
		roomType: 'Room Type',
		roomSelect: 'Stay Dates',
		roomSelectDefault: 'Select Stay Range',
		selectOptionText: 'Choose a date',
	}
});
